import React from 'react';
import { View, Text, TouchableOpacity } from '../../common';
import { SortDirection, SortOptionsMap } from '@zonofi/zono-money-store';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';

interface SortItemProps {
  sortOptions: SortOptionsMap;
  onItemPress: (id: string, direction: SortDirection) => void;
}

export const SortItem: React.FC<SortItemProps> = ({
  sortOptions,
  onItemPress,
}) => {
  return (
    <View className="filter-modal__sort-group">
      {Object.entries(sortOptions).map(([label, { display, selected }]) => (
        <View>
          <Text className="filter-modal__sort-title font-semibold">
            {label?.toUpperCase()}
          </Text>
          <View className="filter-modal__sort-options">
            {Object.entries(display).map(([key, value]) => (
              <TouchableOpacity
                key={key}
                className="filter-modal__sort-option-view"
                onPress={() => onItemPress(label, key as SortDirection)}
              >
                {(key as SortDirection) === selected ? (
                  <RadioButtonCheckedOutlinedIcon className="filter-radio-checked" />
                ) : (
                  <RadioButtonUncheckedOutlinedIcon className="filter-radio-unchecked" />
                )}
                <Text
                  className={`filter-modal__sort-option-text font-medium ${
                    (key as SortDirection) === selected ? 'selected-value' : ''
                  }`}
                >
                  {value}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};
